import React, { useState, useEffect } from "react";
import { Button } from "antd";
import "./TesterPaginator.css";

const TesterPaginator = ({ pages, setCurrent, answers, finish, scrollRef }) => {
    const [selectedKey, setSelectedKey] = useState(null);

    useEffect(() => {
        const savedKey = localStorage.getItem("selectedPageKey");
        if (savedKey && pages.some(p => String(p?.key) === savedKey)) {
            setSelectedKey(savedKey);
        } else if (pages.length > 0) {
            setSelectedKey(pages[0]?.key?.toString());
        }
        console.log(finish)
        if (finish){
            localStorage.removeItem("selectedPageKey")
        }
    }, [pages, finish]);

    const handleClick = (key) => {
        setSelectedKey(key.toString());
        setCurrent(key)
        localStorage.setItem("selectedPageKey", key.toString());
    };

    return (
        <div className="scroll-container" ref={scrollRef}>
            {pages.map((page) => (
                <Button
                    key={page.key}
                    className={`category-button ${String(page?.key) === selectedKey ? "selected" : page?.id in answers ? "marked": ""}`}
                    onClick={() => handleClick(page?.key)}
                >
                    {page?.key}
                </Button>
            ))}
        </div>
    );
};

export default TesterPaginator;
